/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var Area;
(function (Area) {
    let unit;
    (function (unit) {
        unit["SQUARE_METERS"] = "square_meters";
        unit["SQUARE_FEET"] = "square_feet";
    })(unit = Area.unit || (Area.unit = {}));
})(Area || (Area = {}));
//# sourceMappingURL=Area.js.map